import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid,
    TextField,
    Button,
    Typography,
} from '@material-ui/core'

import { Phone, LocationOn, Email } from '@material-ui/icons';

import PageTitle from '../components/PageTitle';
import * as Api from '../api/api';

import contact from '../images/contact.svg';

const styles = theme => ({
  root: {
    paddnig: 20
  },
  mt30: {
    marginTop: 30
  },
  container: {
    padding: 20,
    marginTop:30,
    marginBottom:10,
  },
  imgContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    marginRight: 10,
    color: theme.palette.grey.main,
  },
  info: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
});

class Contact extends Component {

  state = {
    name: '',
    phone: '',
    email: '',
    message: '',
    errors: {},
    submitted: false
  }

  change = (ev) => {
    this.setState({ [ev.target.name]: ev.target.value });
  }

  submit = async () => {
      if (this.validate()) {
        try {
          const res = await this.post();
          if (res.data && res.data.status === 'OK') {
            this.setState({
              name: '',
              phone: '',
              email: '',
              message: '',
              errors: {},
              submitted: true
            })
          }
        } catch (err) {
          console.error(err);
        }
      }
  }

  validLength = (str, len) => {
      if (str.length < len) {
          return false;
      }

      return true;
  }

  isEmail = email => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validate = () => {
    const { name, email, phone, message } = this.state;
    const errors = {};
    if (!this.validLength(name, 3)) {
        errors.name = 'Please enter valid name';
    }

    if (!this.isEmail(email)) {
        errors.email = 'Please enter valid email';
    }

    if (!this.validLength(phone, 10)) {
        errors.phone = 'Please enter valid phone';
    }

    if (!this.validLength(message, 5)) {
        errors.message = 'Message should have at least 5 characters';
    }

    if (isEmpty(errors)) {
        return true;
    }

    this.setState({ errors });
    return false;
  }

  post = async () => {
    const { errors, ...data } = this.state;
    return await Api.postContact(data);
  }

  renderForm = () => {
      const { classes } = this.props;
      const { name, email, phone, message, errors } = this.state;
      return  (
                <form className={classes.container} noValidate autoComplete="off">
                  <TextField
                    name="name"
                    label="Name"
                    value={name}
                    margin="normal"
                    fullWidth
                    onChange={this.change}
                    error={errors.name}
                    helperText={errors.name}
                  />

                  <TextField
                    name="email"
                    label="Email"
                    value={email}
                    margin="normal"
                    fullWidth
                    onChange={this.change}
                    error={errors.email}
                    helperText={errors.email}
                  />

                  <TextField
                    name="phone"
                    label="Phone"
                    value={phone}
                    margin="normal"
                    fullWidth
                    onChange={this.change}
                    error={errors.phone}
                    helperText={errors.phone}
                  />

                  <TextField
                    name="message"
                    label="Message"
                    value={message}
                    margin="normal"
                    multiline
                    rowsMax={5}
                    fullWidth
                    onChange={this.change}
                    error={errors.message}
                    helperText={errors.message}
                  />

                  <Button
                    color="primary"
                    className={classes.root}
                    fullWidth
                    size="large"
                    variant="contained"
                    onClick={this.submit}
                  >
                    Submit
                  </Button>
                </form>
      )
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <PageTitle title="Contact Us" />
        <Grid
          container
          className={classes.container}
          direction="row"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12} sm={8}>
            <Grid
              container
              direction="row"
              alignItems="flex-start"
              justify="center"
              spacing={2}
            >
              <Grid item xs={6}>
                <Typography variant="h6" color="primary" align="center">
                    Fill out the form to leave us a message
                </Typography>
                {this.renderForm()}
                {this.state.submitted && (
                  <Typography variant="h6" align="center">
                    Thank you!
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                <div className={classes.info}>
                    <Phone className={classes.icon}/>
                    <Typography variant="h6" className={classes.icon}>
                        Phone:
                    </Typography>
                    <Typography variant="body1">
                        (305) 742-8775
                    </Typography>
                </div>

                <div className={classes.info}>
                    <Email className={classes.icon}/>
                    <Typography variant="h6" className={classes.icon}>
                        Email:
                    </Typography>
                    <Typography variant="body1">
                        drjmusicologystudio@gmail.com
                    </Typography>
                </div>

                <div className={classes.info}>
                    <LocationOn className={classes.icon}/>
                    <Typography variant="h6" className={classes.icon}>
                        Address:
                    </Typography>
                    <Typography variant="body1">
                        Cooper City, FL 33328
                    </Typography>
                </div>
                <img src={contact} className={classes.mt30} alt="contact us" width="300" />
              </Grid>

            </Grid>
          </Grid>

        </Grid>
      </div>
    )
  }
}

Contact.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Contact);
